import {createPinia} from 'pinia';

const permanentStoreIds = ['session'];

const syncStorage = content => {
  const storeId = content.store.$id;

  if (permanentStoreIds.includes(storeId)) {
    const json = localStorage[storeId];
    const data = json ? JSON.parse(json) : {};
    content.store.$patch({...data});
    content.store.$subscribe((mutation, state) => {
      localStorage[mutation.storeId] = JSON.stringify(state);
    })
  }
};

const pinia = createPinia();
pinia.use(syncStorage);

export default pinia;
